<template>
    <div>
        <div class="text-center mb-5 mt-3">
            <router-link :to="{ name: 'front.home' }" class="button button effect-button mb-3 mt-0">
                <span>{{ $t("gracias.volver") }}</span>
            </router-link>

            <div class="h5">
                <template v-if="es_internacional">
                    {{ $t("gracias.gracias_duda", { email: manager.email_incidencias ? manager.email_incidencias : "info@compralaentrada.com"}) }}
                </template>
                <template v-else>
                    {{ $t("gracias.abonos_enviados", { email: manager.email_incidencias ? manager.email_incidencias : "info@compralaentrada.com", abonos: teatro.texto_abonos }) }}
                </template>
            </div>

            <div class="h5" v-if="configuracion.aviso_gracias" v-html="configuracion.aviso_gracias"></div>
        </div>
        <template v-for="(datos_comprador, i) in datos_compradores">
            <div class="new-subscriber new-subscriber-confirmation mt-2 mb-2 mt-2 mb-2 lightgray-content p-3" :key="i">
                <div class="mb-3 text-uppercase h5 lightgray-content py-2" v-if="!es_internacional">
                    <strong class="mb-2 red">Abono {{ i + 1 }}:</strong> {{ datos_comprador.nombre_zona }}
                    <span v-if="datos_comprador.fila > 0">
                        / {{ $t("general.fila") }}: {{ datos_comprador.fila }}
                    </span>
                    <span v-if="datos_comprador.asiento > 0">
                        / {{ $t("general.butaca") }}: {{ datos_comprador.asiento }}
                    </span>
                    <span v-if="datos_comprador.abonado && datos_comprador.abonado.plaza">
                        <template v-if="datos_comprador.abonado?.plaza?.fila && datos_comprador.abonado?.plaza?.butaca">
                            {{ $t("general.fila") }}: {{ datos_comprador.abonado?.plaza?.fila }} / {{ $t("general.butaca") }}: {{ datos_comprador.abonado?.plaza?.butaca }}
                        </template>
                        <template v-else>
                            {{ $t('general.plaza') }} {{ datos_comprador.abonado?.plaza?.numero }}
                        </template>
                    </span>
                </div>
                <div class="d-flex align-items-center mb-1">
                    <div>
                        <strong class="text-uppercase h6">
                            {{ datos_comprador.nombre }} {{ datos_comprador.apellidos }}
                        </strong>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-lg-5">
                        <label class="mb-2">{{ $t("gracias.datos_personales") }}</label>
                        <div class="d-flex align-items-center mb-1">
                            <div>
                                <i class="fa fa-user"></i> {{ datos_comprador.nombre }}
                            </div>
                        </div>
                        <div class="d-flex align-items-center mb-1">
                            <div>
                                <i class="fa fa-id-card"></i> {{ datos_comprador.dni }}
                            </div>
                        </div>
                        <div class="d-flex align-items-center mb-1">
                            <div>
                                <i class="fa fa-envelope"></i> {{ datos_comprador.email }}
                            </div>
                        </div>
                        <div class="d-flex align-items-center mb-1">
                            <div>
                                <i class="fa fa-phone"></i> {{ datos_comprador.telefono }}
                            </div>
                        </div>

                        <div class="d-flex align-items-center mb-0" v-if="datos_comprador.url_imprimir != null">
                            <a 
                                :href="datos_comprador.url_imprimir" 
                                class="button"
                                target="_blank"
                            >
                                {{ $t("gracias.imprimir_abono", {abono: teatro.texto_abono}) }}
                            </a>
                        </div>
                    </div>
                    <div class="col-12 col-lg-5">
                        <div class="d-block" v-if="datos_comprador.descuento">
                            <label>{{ $t("gracias.tipo_abono", {abono: teatro.texto_abono}) }}</label>
                            <div class="h3 price mt-0">
                                <span class="h4">
                                    {{ datos_comprador.descuento }}
                                </span>
                            </div>
                        </div>
                        <div class="d-block" v-if="datos_comprador.precio">
                            <label>
                                {{ $t("gracias.precio_abono", {abono: teatro.texto_abono}) }}
                            </label>
                            <div class="h3 price mt-0">
                                <span class="h2">
                                    <span v-if="!datos_comprador.price_management_interno && ! datos_comprador.plazos">
                                        {{ (datos_comprador.importe + datos_comprador.price_management) | formatear_precio }}
                                    </span>
                                    <span v-else>
                                        {{ datos_comprador.importe | formatear_precio }}
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <b-col cols="12" class="mt-3" v-if="datos_comprador.abonado.segundo_elegido">
                        <h3>El momento seleccionado es el: <span class="price price-large gradient-color">{{ formatSeg(datos_comprador.abonado.segundo_elegido) }}</span></h3>
                    </b-col>
                </div>
                <div class="col-12 text-center mt-4" v-if="! es_lfp">
                    <a class="button button effect-button" :href="datos_comprador.abonado.url_descarga_abonado" target="_blank">
                        <span>{{ $t('gracias.descargar_pdf_abono') }}</span>
                    </a>
                    <a class="ml-3 button button effect-button" :href="datos_comprador.abonado.url_descarga_passbook" target="_blank">
                        <span>{{ $t('gracias.obtener_passbook') }}</span>
                    </a>
                </div>
                <div class="col-12 col-lg-5 mt-4" v-if="datos_comprador.plazos && datos_comprador.plazos.length > 0">
                    <h4>Plazos:</h4>
                    <ul>
                        <li v-for="plazo in datos_comprador.plazos" :key="plazo.id">
                            <b>{{ plazo.fecha_cobro }}: </b> {{ plazo.price_management_interno ? plazo.importe : plazo.importe + plazo.price_management | formatear_precio }} {{ plazo.estado == 1 ? 'Pagado' : 'Pendiente' }}
                        </li>
                    </ul>
                    <span class="h4">Total: {{ getTotalPlazos(datos_comprador.plazos) | formatear_precio }}</span>
                </div>
                <b-col cols="12" class="pl-0" v-if="datos_comprador.abonado.parcelas?.length">
                    <hr/>
                    <h4>{{ teatro.hash === 'J1fKG9AarPuPNJ5hwY0t' ? "Terrenos" : "Parcelas" }}</h4>
                    <DatosParcelas 
                        v-for="(parcela, index) in datos_comprador.abonado.parcelas"
                        :key="index"
                        :parcela="parcela"
                    />
                </b-col>
            </div>
        </template>
        <template v-if="datos_compradores[0].envio_id != null">
            <div class="mt-2 lightgray-content p-3">
                <div class="text-uppercase h5">
                    <strong class="red">PEDIDO: Nº:</strong>
                    <strong class="ml-1">{{ datos_compradores[0].tpv_order }}</strong> <br />
                </div>
                <span class="h3">TOTAL CON GASTOS DE ENVÍO: </span>
                <span class="h3">
                    {{ (totalAbonosConEnvio + totalParcelas) | formatear_precio }} <span>(Gastos de envío: {{ lista_abonados.precio_envio_a_domicilio | formatear_precio }})</span>
                </span>
            </div>
        </template>
        <b-row v-if="teatro.hash === 'J1fKG9AarPuPNJ5hwY0t'" class="mt-5">
            <b-col cols="12">
                <h3>Camiseta Campaña “Y Mientras Todo Llega…”</h3>
                <p>¡Completa tu abono con la camiseta especial!</p>
                <p>Camiseta oversize alta calidad diseñada en colaboración con el artista murciano El Tipo Raro, esta camiseta captura con su trazo único todo aquello que define al murcianismo más auténtico: la nostalgia, la esperanza, el barrio, la piel de gallina y el orgullo de estar incluso cuando no es fácil.</p>
                <p>Precio y disponibilidad</p>
                <ul>
                    <li>Precio especial para abonados: 19,95 €</li>
                    <li>Precio general: 29,95 €</li>
                </ul>
                <a 
                    href="https://www.realmurcia.es/tiendaonline/categoria-producto/camiseta-campana/" 
                    class="button"
                    target="_blank"
                >
                    Ir a la tienda
                </a>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import DatosParcelas from './components/DatosParcelas';

    export default {
        props: {
            datos_compradores: {
                required: true,
                type: Array
            },
            es_internacional: {
                required: true,
                type: Boolean
            },
            es_lfp: {
                required: false,
                type: Boolean,
                default: false
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            teatro(){
                return this.$store.getters.getTeatro
            },
            lista_abonados() {
                return this.$store.getters.getListaActiva;
            },
            totalAbonosConEnvio() {
                var total = 0;

                for (var i in this.datos_compradores) {
                    total += parseFloat(this.datos_compradores[i].precio);

                    if (this.lista_abonados.precio_envio_a_domicilio > 0) {
                        total += this.lista_abonados.precio_envio_a_domicilio;
                    }
                }

                return total;
            },
            totalParcelas() {
                let total = 0;

                this.datos_compradores.forEach(datos => {
                    if (datos.abonado && datos.abonado.parcelas?.length) {
                        datos.abonado.parcelas.forEach(parcela => {
                            total += parseFloat(parcela.precio)
                        });
                    }
                });

                return total;
            }
        },
        methods: {
            getTotalPlazos(plazos) {
                let total = 0;
                plazos.forEach(plazo => {
                    if(plazos.price_management_interno) {
                        total += plazo.importe;
                    } else {
                        total += plazo.importe + plazo.price_management;
                    }
                })

                return total;
            },
            formatSeg(segundo) {
                const minutes = Math.floor(segundo / 60);
                const remainingSeconds = segundo % 60;
                return `Min: ${minutes} - Seg: ${remainingSeconds}`;
            },
        },
        components: {
            DatosParcelas
        }
    }
</script>

<style scoped>
    .price-large {
        font-size: 40px !important;  
    }
</style>
